import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  services: [
    {
      id: 1,
      title: 'Fintech Solutions',
      description: 'Cutting-edge financial technology solutions for modern banking and payment systems.',
      icon: 'CreditCard',
      features: ['Payment Processing', 'Digital Banking', 'Blockchain Integration', 'Risk Management']
    },
    {
      id: 2,
      title: 'ERP Systems',
      description: 'Comprehensive Enterprise Resource Planning solutions to streamline your business operations.',
      icon: 'Building2',
      features: ['Resource Management', 'Process Automation', 'Data Analytics', 'Cloud Integration']
    },
    {
      id: 3,
      title: 'Supply Chain Management',
      description: 'Optimize your supply chain with our advanced logistics and inventory management systems.',
      icon: 'Truck',
      features: ['Inventory Tracking', 'Logistics Optimization', 'Vendor Management', 'Real-time Analytics']
    },
    {
      id: 4,
      title: 'SDLC Solutions',
      description: 'Complete Software Development Life Cycle management and DevOps implementation.',
      icon: 'Code',
      features: ['Agile Development', 'CI/CD Pipelines', 'Quality Assurance', 'Project Management']
    },
    {
      id: 5,
      title: 'Cloud Services',
      description: 'Scalable cloud infrastructure and migration services for modern businesses.',
      icon: 'Cloud',
      features: ['Cloud Migration', 'Infrastructure Management', 'Security Solutions', 'Cost Optimization']
    },
    {
      id: 6,
      title: 'AI & Machine Learning',
      description: 'Harness the power of artificial intelligence to transform your business processes.',
      icon: 'Brain',
      features: ['Predictive Analytics', 'Natural Language Processing', 'Computer Vision', 'Automation']
    }
  ],
  selectedService: null,
};

const servicesSlice = createSlice({
  name: 'services',
  initialState,
  reducers: {
    selectService: (state, action) => {
      state.selectedService = action.payload;
    },
    clearSelectedService: (state) => {
      state.selectedService = null;
    },
  },
});

export const { selectService, clearSelectedService } = servicesSlice.actions;
export default servicesSlice.reducer;
